<template lang="pug">
.main
  .section
    .content
      .personal-info
        me-avatar
        //.membership
        .refresh(@click="toAuth()")
          img(src="~assets/refresh.png")
      .br
      .fam
        avatar-stack(:noMe="true")
        my-router-link(from="/me/main" to="/footprint/sticker")
          arrow-btn(copy="我的贴纸库")
    blue-shadow2
  .section.res
    .copy
      .title 我的预约
      my-router-link(from="/me/main" to="/me/res")
        arrow-btn(copy="查看")
    .card-wrapper(v-if="getReses && getReses.length>0")
      res-info-card(:res="getReses[0]" :noArrow="true" from="/me/main" :id="getReses[0].resId")
  //- .section.survey
  //-   .copy
  //-     .title 我的问卷
  //-   .card-wrapper
  //-     img(src="~assets/card-survey.png")
  //- .section.footprint
  //-   .copy
  //-     .title 我的足迹
  //-   my-router-link(from="/me/main" to="/me/footprint")
  //-     .card-wrapper
  //-       img(src="~assets/card-report.png")
  //.footprint
    .copy
      .title 我的足迹
      arrow-btn(copy="查看" from="/me/main" to="/me/footprint")
    .slides
      footprint-slides

  
</template>
<script>
import Flex from '@/components/Flex'
import { mapGetters, mapMutations } from 'vuex'
import MeAvatar from '@/components/me/MeAvatar'
import AvatarStack from '@/components/wedgits/AvatarStack'
import ArrowBtn from '@/components/wedgits/ArrowBtn'
import BlueShadow from '@/components/wedgits/BlueShadow'
import BlueShadow2 from '@/components/wedgits/BlueShadow2'
import ResInfoCard from '@/components/me/ResInfoCard'
import FootprintSlides from '@/components/me/FootprintSlides'
import BlueShadow3 from '@/components/wedgits/BlueShadow3'
import MyRouterLink from '@/components/wedgits/MyRouterLink'
import AlipayService from '@/services/AlipayService'
export default {
  name: 'Main',
  components: {
    MyRouterLink,
    BlueShadow3,
    FootprintSlides,
    ResInfoCard,
    BlueShadow2,
    BlueShadow,
    ArrowBtn,
    AvatarStack,
    MeAvatar,
    Flex,
  },
  props: {},
  created() { },
  data() {
    return {
      timeTable: [],
    }
  },
  computed: {
    ...mapGetters('app', ['getLatestRes', 'getReses']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),

    onNext() { },
    toAuth(){
      // this.pending = false
      //     this.setPending(false)
      AlipayService.sendEvent(AlipayService.Events.USER_AUTH_REQUEST)
    
    }
  },
  mounted() { 
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.main
  //padding: pxToRem(30)
  //background: #ffffff
  position: absolute
  width: 100%
  height: 100%
  .section
    width: 100%
    position: relative
    .content
      position: relative
      z-index: 10
      background: #ffffff
    .personal-info
      width: 100%
      height: pxToRem(96)
      display: flex
      justify-content: space-between
      align-items: baseline
      padding: pxToRem(30)
      .refresh
        position: absolute;
        right: pxToRem(50);
        top: pxToRem(60);
        width: pxToRem(44)
        height: pxToRem(44)
        img
          width: 100%
          height: 100%
          display: block
    .br
      position: relative
      width: pxToRem(690)
      left: pxToRem(30)
      height: pxToRem(60)
      border-bottom: #d8d8d8 pxToRem(1) solid
    .fam
      position: relative
      z-index: 2
      background: #ffffff
      margin-top: pxToRem(50)
      display: flex
      flex-direction: row
      justify-content: space-between
      align-items: center
      padding-bottom: pxToRem(50)
      padding-left: pxToRem(30)
      padding-right: pxToRem(30)
    .blue-shadow2
      z-index: 1 !important
      //bottom: 0
    //.shadow
      margin-left: pxToRem(-30)
      width: pxToRem(750)
  .section
    //margin-top: pxToRem(40)
    .copy
      display: flex
      justify-content: space-between
      align-items: center
      padding: pxToRem(30)
      .title
        font-size: pxToRem(34)
        color: black
    .card-wrapper
      //width: pxToRem(700)
      width: 90%
      height: pxToRem(188)
      margin: auto
      //overflow: hidden
      //background: black
      display: flex
      justify-content: center
      align-items: flex-start
      img
        //margin-top: pxToRem(10)
        position: absolute
        width: 95%
        object-fit: contain
  .res
    margin-top: pxToRem(40)
    //.card
      position: relative
      width: 100%
      padding: 0 pxToRem(30)
  .footprint
    //margin-top: pxToRem(20)
    //.slides
      width: 100%
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
